import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const ImageMatting = () => {
  const { t } = useI18n();

  // 创建智能抠图的配置
  const config = createComponentConfig({
    toolName: t('aiWorkbench.tools.imageMatting.title'),
    toolIcon: '✂️',
    toolDescription: t('aiWorkbench.tools.imageMatting.description'),
    gradientColors: ['#FF9A9E', '#FECFEF'], // Soft pink/purple gradient
    
    // API配置
    apiEndpoint: '/image-matting',
    
    // 组件配置
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'sourceImage',
        title: t('aiWorkbench.tools.imageMatting.ui.uploadTitle'),
        description: t('aiWorkbench.tools.imageMatting.ui.uploadDescription'),
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'webp'],
          maxSize: 10 * 1024 * 1024,
          preview: true,
          placeholder: t('aiToolTemplate.clickOrDragUpload')
        }
      }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        }
      })
    ],

    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    
    // 布局配置
    layout: 'default'
  });

  return (
    <AiToolTemplateV2
      toolName={config.toolName}
      toolIcon={config.toolIcon}
      toolDescription={config.toolDescription}
      config={config}
      gradientColors={config.gradientColors}
      toolId={TOOL_IDS.IMAGE_MATTING}
    />
  );
};

export default ImageMatting;
